import { Component, OnInit } from '@angular/core';
import { PqrsService } from 'src/app/servicios/public/pqrs.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import swal from 'sweetalert2';
import { Loading } from 'src/app/Class/Loading';
import { Router } from '@angular/router';
import { getDate } from 'date-fns';
import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
declare var $: any;

@Component({
  selector: 'app-pqrs',
  templateUrl: './pqrs.component.html',
  styleUrls: ['./pqrs.component.css']
})
export class PQRSComponent implements OnInit {

  public recursos: any = {} ;
  public errores: any = [];
  public tipoCasoSelect = null;
  public doc: FormGroup;
  public form: FormGroup;
  public departamentos: any = [];
  public municipios: any = [];
  public programasSelect: any = [];
  public paisSelect: any;
  public depSelect: any;
  
  //variables para obtener la fecha actual
  public fecha = new Date();
  public hoy = '';

  //Variable para enviar una sola vez la petición
  public procesando = false;

  //Expresiones regulares 
  public expRegNombre = '[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+';
  public expRegCorreo = '^[a-zA-Z]+([a-zA-Z0-9]*[._-]{1}[a-zA-Z0-9]+)*@[a-zA-Z0-9]+([._-]{1}[a-zA-Z0-9]+)*([.]{1}[a-zA-Z]{2,4})+$';

  public is_disable: boolean = true;
  public disableBusqueda: boolean = false;

  constructor( private servi: PqrsService, private fb: FormBuilder, public loading: Loading, private router: Router) {
 
    this.servi.getRecursos()
    .subscribe( (data: any) => { this.recursos = data; });

    this.doc = this.fb.group({
      numeroDocumento: [Validators.required],
     // tip_doc: [Validators.required]
    });

    this.form = this.fb.group({
      /*tabla personas*/
      tipo_documento: [, Validators.required ],
      documento: [{value: null, disabled: false},Validators.required],
      nombres: [{value: null, disabled: false},Validators.required],
      apellidos: [{value: null, disabled: false},Validators.required],
      razon_social: [null],
      
      /*tabla pqrs*/
      telefono: [null, [Validators.required, Validators.maxLength(14)]], //se carga de tabla personas, se almacena en pqrs, se puede modificar
      email: [null, [Validators.required, Validators.email, Validators.maxLength(250)]], //se carga de tabla personas, se almacena en pqrs, se puede modificar
      tipo_vinvulacion: [null, Validators.required ], //id tabla tipos_vinculacion_universidad
      direccion: [null, [Validators.required, Validators.maxLength(100)]], //se carga de tabla personas, se almacena en pqrs, se puede modificar
      descripcion: [null, [Validators.required, Validators.maxLength(1500)]],
      tipo_caso: [null, [Validators.required ]], //id tabal tipos_situacion_caso
      vinculacion_externa_id:[null],
      vinculacion_externa_nombre: [''], //si la respuesta es otro 
      medio_respuesta: [null, Validators.required], //id tabla medio_respuesta
      tipo_solicitante: [null, Validators.required], //id tabla tipos_solicitante
      municipio: [null, Validators.required], //id tabla municipio

      /*tabla denuncia*/
      lugar: [null],
      fecha: [null], 
      
      /*Tabla archivos_pqrs */
      archivos: [[]],

      paisSelect:[null, [Validators.required ]],
      depSelect:[null, [Validators.required ]],
      tipoCasoSelect:[null, [Validators.required ]],
      facultadId:[null],
      facultadSelect:[null],
      programaId:[null],

      infoIp:[null]
    });

    this.servi.getInfoIp()
    .then(r=>{ 
      this.form.get('infoIp').setValue( JSON.stringify(r) );
    });

  }

  ngOnInit() {
    //fecha actual
    this.hoy = this.fecha.getFullYear()+"-"+this.limpiarNumero(this.fecha.getMonth()+1)+"-"+this.limpiarNumero(this.fecha.getDate())+"T23:59";
    this.validationsCaseType();
    
    //$("#modalMensaje").modal("show");
    this.verTutorial();

    $('#tutorialPQRModal').on('hidden.bs.modal', function () {
      $('video').trigger('pause');
    });

  }

  verTutorial()
  {
    $("#tutorialPQRModal").modal("show");
    this.ensureVideoPlays();
  }

  private ensureVideoPlays(): void
  {
      const video = document.querySelector("video");

      if(!video) return;
      
      const promise = video.play();
      if(promise !== undefined){
          promise.then(() => {
              // Autoplay started
          }).catch(error => {
              // Autoplay was prevented.
              video.muted = true;
              video.play();
          });
      }
  }

  setTypeCase(valueId){
    this.form.get("tipo_caso").setValue(valueId)
    this.validationsCaseType();
  }
  validationsCaseType(){
    this.form.get('tipo_caso').valueChanges.subscribe(val => {
      if (val == 8){
        this.form.controls['lugar'].setValidators([Validators.required]);
      }else{
        this.form.controls['lugar'].clearValidators();
        this.form.controls["lugar"].updateValueAndValidity();
      }
    });
  }
  //funcion para agregar un cero a los numeros de 1 al 9
  limpiarNumero(n: number){
    return n < 10 ? '0'+n : n.toString();
  }

  // validarFecha(){
  //   var fechaInput = document.getElementById('fechaDenuncia');
  //   var fechaIngresada = (<HTMLInputElement>fechaInput).value;
  //   this.ngOnInit();

  //   if(Date.parse(fechaIngresada) > Date.parse(this.hoy)){
  //     if(fechaIngresada == null){
  //       $('#Modalerrores').modal({ backdrop: 'static', keyboard: true, show: true });
  //       (<HTMLInputElement>fechaInput).value = '';
  //       return this.errores = ["Debe ingresar la fecha y hora en que ocurrio el suceso"];

  //     }else{
  //       $('#Modalerrores').modal({ backdrop: 'static', keyboard: true, show: true });
  //       (<HTMLInputElement>fechaInput).value = '';
  //       return this.errores = ["La fecha no puede ser mayor a la fecha actual"];
  //     }  
      
  //   }
  // }


  // validar extensiones de archivos
  validarExtension (event) {
   var archivoInput = document.getElementById('fileUpload');
   var archivoRuta = (<HTMLInputElement>archivoInput).value;
   var extPermitidas = /(.pdf)$/i; 

    if(!extPermitidas.exec(archivoRuta)){
      $('#Modalerrores').modal({ backdrop: 'static', keyboard: true, show: true });
      (<HTMLInputElement>archivoInput).value = '';
      return this.errores = ["Solo se aceptan archivos con extensión PDF"];
    
}else{
      this.onFileSelect(event);
    }
  }
  
  buscarDoc(){
    this.loading.estado = true;
    this.is_disable=true;
    this.servi.buscarDoc(this.form.value.documento,this.form.value.tipo_documento)
    .subscribe(data => {
      this.loading.estado = false;
      if (data && data['nombres'] != null) {
        this.disableBusqueda = true;
        this.form.get('nombres').setValue(data['nombres']);
        this.form.get('apellidos').setValue(data['apellidos']);
      }
      });
    this.loading.estado = false;
  }
  validateForm(){
    if (this.form.invalid) {


      Object.values(this.form.controls).forEach(control => {

        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }


      });
      return false;
    }
    return true;
  }

  guardar() {
    
    if(this.procesando == true ){ return; }
    if( !this.validateForm() ){ return; }

    /*if (!this.form.valid) {
      this.errores = this.form.errors;
      $('#Modalerrores').modal({ backdrop: 'static', keyboard: true, show: true });
      return this.errores;
    }*/

    this.loading.estado = true;
    this.procesando = true;

    this.servi.guardar(this.form.value)
    .subscribe(data => {
      this.procesando = false;
      this.loading.estado = false;
      if (data['success']) {

        swal.fire( 'Gracias por contactarnos', "Su PQR fue recibida y radicada con el No. "+ data['radicado'], 'success')
        .then((result) => {
          this.router.navigate(['/ConsultarPQRS/' + data['radicado']]);
        }); 
        
       } else {
         $('#Modalerrores').modal({ backdrop: 'static', keyboard: true, show: true });
         this.errores = data['errores'];
        }
    });

  }

  onFileSelect(event) {

    if (event.target.files.length > 0) {
      var files = [];
      for(var i=0; i<event.target.files.length; i++){ files[i] = event.target.files[i]; }
      this.form.get('archivos').setValue( files );
    }

  }

  filtrarDep(id) {
    this.departamentos = this.recursos.departamentos.filter(row=>row.pais_id == id);
  }
  filtrarMun(id){
    this.municipios = this.recursos.municipios.filter(row=>row.departamento_id == id);
  }
  getFacultad(facultad){
    this.form.get('facultadId').setValue(facultad.id);
    this.form.get('programaId').setValue(null);
    this.programasSelect = facultad.programas;
  }
}

